/*
 * @Author: hgc
 * @Date: 2024-07-19 17:44:52
 * @LastEditTime: 2024-07-19 17:56:13
 * @LastEditors: hgc
 * @Description:
 * @FilePath: \h5-lcjc-formula\src\utils\category\Pulm.js
 */
/** 呼吸病学 */

/** 对应的标题 */
const categoryMap = {
  BorgCR10: 'Borg CR10 分级',
  Borg: 'Borg 分级',
  CRB65: 'CRB-65评分',
  MMRCdyspnea: '改良呼吸困难分级（mMRC）',
  GOLD: 'GOLD分级',
  // Hestia: 'Hestia 标准',
  MRCdyspnea: '呼吸困难分级（MRC）',
  sPESI: '简易化 PESI',
  Epworth: 'Epworth 嗜睡量表',
  PaO2FiO2ratio: 'PaO₂ / FiO₂ 比',
  AaGradientAndRatio: '肺泡-动脉氧分压差及比值',
  ADO: 'ADO 指数',
  BODEx: 'BODEx 指数',
  PredictedBodyWeightARDS: '潮气量（ARDSnet）',
  CURB65: 'CURB-65评分',
  LungAge: '肺龄',
  PredictedPeakFlow: '峰值流量预测值（成人）',
  SolitaryNodule: '孤立结节评估',
  HendersonHasselbalch: 'Henderson-Hasselbalch',
  SpirometricValues: '呼吸量测定值',
  PSI: '肺炎严重度指数（PSI）',
  InFlightPaO2: '机舱内 PaO₂ 估算',
  MurrayLungInjuryScore: 'Murray肺损伤评分',
  OxygenIndex: '氧合指数（OI）',
  VentilationBloodFlowRatio: '通气血流比',
  VWindicators: '呼吸机撤机指标',
  GAS_Centor: '链球菌咽炎Centor标准',
  ArtOxygenDifference: '动静脉血氧含量差',
  PaO: '预测动脉血氧分压',
  Intrapulmonary_right_to_left_shunt:'肺内右-左分流率',
  Theophylline:"茶碱"
}
/** 对应的描述 */
const categoryDescMap = {
  BorgCR10: '描述对运动的感知',
  Borg: '描述对运动的感知',
  CRB65: '简易CURB-65评分',
  MMRCdyspnea: 'MRC改良版',
  GOLD: 'GOLD 严重性',
  // Hestia: '肺栓塞的院外治疗',
  MRCdyspnea: '评估呼吸困难严重度',
  sPESI: '简化的肺栓塞严重地指数',
  Epworth: '日间嗜睡评估',
  PaO2FiO2ratio: '低氧血症严重度指数。',
  AaGradientAndRatio: 'A - a 氧分压差及比值',
  ADO: 'COPD 预后评估工具',
  BODEx: 'COPD 预后评估工具',
  PredictedBodyWeightARDS: '体重预测值和推荐潮气量',
  CURB65: '社区获得性肺炎死亡率',
  LungAge: '描述吸烟所致的肺损伤',
  PredictedPeakFlow: '用于比较测量值和预测值',
  SolitaryNodule: '孤立性肺部结节恶性风险(Swensen临床预测模型)',
  HendersonHasselbalch: '酸碱方程',
  SpirometricValues: 'FVC 和 FEV1 预测值',
  PSI: '社区获得性肺炎严重度',
  InFlightPaO2: '患者是否需要额外氧气？',
  MurrayLungInjuryScore: '评估ARDS严重度',
  OxygenIndex: '氧气交换指数',
  VentilationBloodFlowRatio: '评估肺换气功能',
  VWindicators: '评估撤机的时机',
  GAS_Centor: '评估链球菌咽炎可能性',
  ArtOxygenDifference: '反映氧代谢情况',
  PaO: '不同年龄及体位'
}
/** 没有公式描述的页面 */
const categoryNotInfoMap = {
}
export default {
  categoryMap,
  categoryDescMap,
  categoryNotInfoMap
}



// WEBPACK FOOTER //
// ./src/utils/category/Pulm.js